
export const WidgetFooterActions = () => {
  return (
    <div className="osirus-agent-footer-actions">
      {/* <a href="#">Terms</a>
      <a href="#">Sign Up</a>
      <a href="#">Sign In</a> */}
       <a href="https://osirus.ai" target="_blank">Powered by Osirus AI</a>
    </div>
  )
}
